export const LANGUAGES = ['html', 'css', 'javascript'];
